import { useEffect } from 'react';
import { useThemeStore, type ThemeId } from '@/store/theme.store';
import { Tooltip } from 'antd';
import {
  MoonOutlined,
  SunOutlined,
  CloudOutlined,
  RiseOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import './ThemeSwitcher.css';

const THEMES: { id: ThemeId; label: string; icon: React.ReactNode }[] = [
  { id: 'dark', label: 'Dark', icon: <MoonOutlined /> },
  { id: 'light', label: 'Light', icon: <SunOutlined /> },
  { id: 'midnight', label: 'Midnight', icon: <CloudOutlined /> },
  { id: 'netcore', label: 'Netcore', icon: <RiseOutlined /> },
  { id: 'forest', label: 'Forest', icon: <EnvironmentOutlined /> },
];

const ThemeSwitcher = () => {
  const { theme, setTheme } = useThemeStore();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <div className="theme-switcher" role="group" aria-label="Theme selector">
      {THEMES.map((t) => (
        <Tooltip key={t.id} title={t.label} placement="bottom">
          <button
            type="button"
            className={`theme-switcher-btn ${theme === t.id ? 'active' : ''}`}
            onClick={() => setTheme(t.id)}
            aria-label={`Switch to ${t.label} theme`}
            aria-pressed={theme === t.id}
          >
            {t.icon}
          </button>
        </Tooltip>
      ))}
    </div>
  );
};

export default ThemeSwitcher;
